module.exports = "/_next/static/pages/proctoring/2af9c790e0d758d62696852361e4c6ca.png";